"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSEAuthRoutes = exports.EAuthRoutes = void 0;
var EAuthRoutes;
(function (EAuthRoutes) {
    EAuthRoutes["DASHBOARD"] = "/dashboard";
    EAuthRoutes["CLAIM_BUSINESS"] = "/claim-business";
    EAuthRoutes["TASK_DETAILS"] = "/task-detail";
    EAuthRoutes["TASK_CREATION"] = "/task-creation";
    EAuthRoutes["TASK_CREATION_EDIT"] = "/edit-task-draft";
    EAuthRoutes["TASK_LIST"] = "/task-list";
    EAuthRoutes["TASK_IMPORT"] = "/import";
    EAuthRoutes["SETTINGS"] = "/settings";
    EAuthRoutes["SETTINGS_BUSINESS_ACCOUNTS"] = "/settings/business-information";
    EAuthRoutes["USER_BUSINESS_ACCOUNTS"] = "/user/business-information";
    EAuthRoutes["SERVICE_AND_INFORMATION"] = "/service-information";
    EAuthRoutes["FLEET"] = "/service-information/fleet";
    EAuthRoutes["SMART_FARMING"] = "/smart-farming";
    EAuthRoutes["USER"] = "/user";
    EAuthRoutes["PROFILE"] = "/profile";
    EAuthRoutes["PERSONAL_DATA"] = "/personal-data";
    EAuthRoutes["DATA_AND_PRIVACY"] = "/data-and-privacy";
    EAuthRoutes["LOGIN_AND_SECURITY"] = "/login-and-security";
    EAuthRoutes["DEVICES"] = "/devices";
    EAuthRoutes["ADD_MACHINE"] = "/add-machine";
    EAuthRoutes["LEGACY_FLEET_LIST"] = "/legacy-fleet-list";
    EAuthRoutes["VERIFY_MACHINE"] = "/verify-machine";
    EAuthRoutes["FLEET_OVERVIEW"] = "/fleet-overview";
})(EAuthRoutes = exports.EAuthRoutes || (exports.EAuthRoutes = {}));
var FLEET = '/fleet';
var SERVICE_AND_INFORMATION = '/service-information';
var PSP = '/psp';
var WARRANTY = '/warranty';
var OVERVIEW = '/overview';
var DIAGNOSTIC_TROUBLE_CODES = '/diagnostic-trouble-codes';
var DTC = '/dtc';
var D_LOCATOR = '/dealer-locator';
var VIDEOS = '/videos';
exports.FSEAuthRoutes = {
    FLEET: FLEET,
    SERVICE_AND_INFORMATION: SERVICE_AND_INFORMATION,
    PSP: PSP,
    WARRANTY: WARRANTY,
    OVERVIEW: OVERVIEW,
    DIAGNOSTIC_TROUBLE_CODES: "".concat(SERVICE_AND_INFORMATION).concat(DIAGNOSTIC_TROUBLE_CODES).concat(DTC),
    FLEET_OVERVIEW: "".concat(SERVICE_AND_INFORMATION).concat(FLEET).concat(OVERVIEW),
    FLEET_WARRANTY: "".concat(SERVICE_AND_INFORMATION).concat(FLEET).concat(WARRANTY),
    FLEET_PSP: "".concat(SERVICE_AND_INFORMATION).concat(FLEET).concat(PSP),
    MANUALS: "".concat(SERVICE_AND_INFORMATION, "/manuals"),
    DEALER_LOCATOR: "".concat(SERVICE_AND_INFORMATION).concat(D_LOCATOR),
    DEALER_LOCATOR_MAIN: D_LOCATOR,
    CONTACT_US: '/contact-us',
    OPEN_SUPPORT_TICKET: '/contact-us/open-support-ticket',
    TICKET_HISTORY: '/contact-us/open-support-ticket/ticket-history',
    VIDEOS: "".concat(SERVICE_AND_INFORMATION).concat(VIDEOS, "/browse-videos"),
};
